import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { FundResponse } from '@cosvision/shared';
import { listFunds, type ListFundsOptions } from '../lib/api/funds.js';
import { qk } from '../lib/query-keys.js';

export function useFundsQuery(opts: ListFundsOptions = {}): UseQueryResult<FundResponse[]> {
  return useQuery({
    queryKey: qk.funds.list(opts),
    queryFn: () => listFunds(opts),
  });
}
